import { hotBoard, hotCategories } from '@/mocks/home';
import SectionHeading from '@/pages/home/components/SectionHeading';

const trendIcon: Record<string, string> = {
  up: 'ri-arrow-up-line text-primary-600',
  down: 'ri-arrow-down-line text-foreground-500',
  flat: 'ri-subtract-line text-foreground-400',
};

export default function HotBoard() {
  return (
    <section id="board" className="w-full bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-20 md:py-28">
        <SectionHeading
          kicker="HOT LIST"
          title="今日热度榜单"
          desc="按实时热度排出的前十位，热度指数越靠前越值得先看。榜单每次刷新都会重新排序。"
          action={{ label: '查看完整榜单', href: '#topics' }}
        />

        <div className="grid lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-8">
            <div className="flex flex-col rounded-lg bg-background-50 border border-background-200/80 overflow-hidden">
              {hotBoard.map((item) => {
                const top3 = item.rank <= 3;
                return (
                  <div
                    key={item.rank}
                    className="flex items-center gap-4 md:gap-6 px-4 md:px-6 py-4 md:py-5 border-b border-background-200/70 last:border-b-0 hover:bg-background-100/60 transition-colors"
                  >
                    <span
                      className={`w-8 md:w-10 shrink-0 font-heading font-black text-xl md:text-2xl ${
                        top3 ? 'text-primary-500' : 'text-foreground-300'
                      }`}
                    >
                      {String(item.rank).padStart(2, '0')}
                    </span>

                    {top3 && item.cover && (
                      <div className="hidden sm:block w-14 h-14 md:w-16 md:h-16 shrink-0 rounded-md overflow-hidden bg-background-200">
                        <img
                          src={item.cover}
                          alt={item.title}
                          title={`${item.title} 看料91热门`}
                          className="w-full h-full object-cover object-top"
                        />
                      </div>
                    )}

                    <div className="flex-1 min-w-0">
                      <h4 className="font-heading font-bold text-foreground-950 text-sm md:text-base leading-snug truncate">
                        {item.title}
                      </h4>
                      <div className="mt-2 flex flex-wrap items-center gap-2">
                        <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 text-[11px] font-medium">
                          {item.category}
                        </span>
                        <span className="text-[11px] text-foreground-500">热度持续更新中</span>
                      </div>
                    </div>

                    <div className="hidden md:flex flex-col items-end w-28 shrink-0">
                      <div className="flex items-center gap-1">
                        <i className={`${trendIcon[item.trend]} text-sm`} />
                        <span className="font-heading font-black text-foreground-950 text-base">
                          {item.heatText}
                        </span>
                      </div>
                      <span className="mt-2 inline-block w-full h-1.5 rounded-full bg-background-200 overflow-hidden">
                        <span
                          className="block h-full rounded-full bg-primary-500 origin-left animate-grow-bar"
                          style={{ width: `${item.heatValue}%` }}
                        />
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-32 space-y-6">
              <div className="p-6 md:p-7 rounded-lg bg-foreground-950 text-background-50">
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-semibold">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-fire-fill" />
                  </span>
                  本期爆款
                </div>
                <h4 className="mt-5 font-heading font-black text-xl md:text-2xl leading-snug">
                  城市夜行 · 深夜街巷特辑
                </h4>
                <p className="mt-3 text-sm text-background-200/80 leading-relaxed">
                  上线两小时热度冲到 98.6，成为近期讨论度最高的爆款内容。
                </p>
                <div className="mt-6 flex items-center gap-4">
                  <div className="flex-1">
                    <div className="text-xs text-background-100/60">爆款指数</div>
                    <div className="font-heading font-black text-accent-400 text-2xl">98.6</div>
                  </div>
                  <a
                    href="#focus"
                    className="inline-flex items-center gap-1 px-4 py-2 rounded-md bg-background-50 text-foreground-950 text-sm font-semibold hover:bg-background-200 transition-colors whitespace-nowrap"
                  >
                    看详情
                  </a>
                </div>
              </div>

              <div className="p-6 md:p-7 rounded-lg bg-background-50 border border-background-200/80">
                <h4 className="font-heading font-bold text-foreground-950 text-base md:text-lg">
                  分类热度
                </h4>
                <div className="mt-6 space-y-5">
                  {hotCategories.map((cat) => (
                    <div key={cat.name}>
                      <div className="flex items-center justify-between text-sm">
                        <span className="text-foreground-800 font-medium">{cat.name}</span>
                        <span className="text-primary-600 font-semibold">{cat.delta}</span>
                      </div>
                      <span className="mt-2 block h-2 rounded-full bg-background-200 overflow-hidden">
                        <span
                          className="block h-full rounded-full bg-accent-500 origin-left animate-grow-bar"
                          style={{ width: `${cat.heat}%` }}
                        />
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}